import type { RouteObject } from "react-router-dom";
import { addSlashes } from "../route.utils";
import {
  CreatePassword,
  ForgotPassword,
  Impersonate,
  Login,
  ResetPassword,
  SignInMFAVerification,
  SignUp,
  SignupOTPVerification,
  VerifyOtp,
} from "@/utils/lazyLoadComponents";

// ─── Path Segments ────────────────────────────────────────────────────────────
export enum AUTH_PATH_SEGMENTS {
  ROOT = "auth",
  LOGIN = "login",
  MFA = "mfa",
  SIGN_UP = "sign-up",
  VERIFY_OTP = "verify-otp",
  VERIFY_EMAIL = "verify-email",
  CREATE_PASSWORD = "create-password",
  FORGOT_PASSWORD = "forgot-password",
  RESET_PASSWORD = "reset-password",
  IMPERSONATE = "impersonate",
}

// ─── Route Definition ─────────────────────────────────────────────────────────
export const authRoutes: RouteObject[] = [
  {
    path: AUTH_PATH_SEGMENTS.LOGIN,
    children: [
      {
        path: "",
        Component: Login,
      },
      {
        path: AUTH_PATH_SEGMENTS.MFA,
        Component: SignInMFAVerification,
      },
    ],
  },
  { path: AUTH_PATH_SEGMENTS.SIGN_UP, Component: SignUp },
  { path: AUTH_PATH_SEGMENTS.VERIFY_OTP, Component: VerifyOtp },
  { path: AUTH_PATH_SEGMENTS.VERIFY_EMAIL, Component: SignupOTPVerification },
  { path: AUTH_PATH_SEGMENTS.CREATE_PASSWORD, Component: CreatePassword },
  { path: AUTH_PATH_SEGMENTS.FORGOT_PASSWORD, Component: ForgotPassword },
  { path: AUTH_PATH_SEGMENTS.RESET_PASSWORD, Component: ResetPassword },
  { path: AUTH_PATH_SEGMENTS.IMPERSONATE, Component: Impersonate },
];
// ─── Resolved Paths ───────────────────────────────────────────────────────────
export const AUTH_PATHS = Object.freeze({
  ROOT: addSlashes(AUTH_PATH_SEGMENTS.ROOT),
  LOGIN: addSlashes(AUTH_PATH_SEGMENTS.ROOT, AUTH_PATH_SEGMENTS.LOGIN),
  MFA: addSlashes(
    AUTH_PATH_SEGMENTS.ROOT,
    AUTH_PATH_SEGMENTS.LOGIN,
    AUTH_PATH_SEGMENTS.MFA,
  ),
  SIGN_UP: addSlashes(AUTH_PATH_SEGMENTS.ROOT, AUTH_PATH_SEGMENTS.SIGN_UP),
  VERIFY_OTP: addSlashes(
    AUTH_PATH_SEGMENTS.ROOT,
    AUTH_PATH_SEGMENTS.VERIFY_OTP,
  ),
  VERIFY_EMAIL: addSlashes(
    AUTH_PATH_SEGMENTS.ROOT,
    AUTH_PATH_SEGMENTS.VERIFY_EMAIL,
  ),
  CREATE_PASSWORD: addSlashes(
    AUTH_PATH_SEGMENTS.ROOT,
    AUTH_PATH_SEGMENTS.CREATE_PASSWORD,
  ),
  FORGOT_PASSWORD: addSlashes(
    AUTH_PATH_SEGMENTS.ROOT,
    AUTH_PATH_SEGMENTS.FORGOT_PASSWORD,
  ),
  RESET_PASSWORD: addSlashes(
    AUTH_PATH_SEGMENTS.ROOT,
    AUTH_PATH_SEGMENTS.RESET_PASSWORD,
  ),
  IMPERSONATE: addSlashes(
    AUTH_PATH_SEGMENTS.ROOT,
    AUTH_PATH_SEGMENTS.IMPERSONATE,
  ),
});
